// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1CTzX","MainHeading":"Header_MainHeading__1z2iT","headerBtnsBox":"Header_headerBtnsBox__1S6xP"};